import { cn } from 'utils/cn.tsx';
import { Icon } from 'components/atoms/Icon.tsx';
import type { ComponentChildren } from 'preact';
import { localize } from 'i18n/localize.ts';

export type Props = {
	header: ComponentChildren | ((titleClassName?: string, onHeaderClick?: () => void) => JSX.Element);
	onClose: () => void;
	className?: string;
	titleClassName?: string;
	closeButtonTitle?: string;
	closeButtonClassName?: string;
	onHeaderClick?: () => void;
};

const $t = localize();

export function ModalHeader({
	header,
	onClose,
	className,
	titleClassName,
	closeButtonTitle = $t.modal.close,
	closeButtonClassName,
	onHeaderClick,
}: Props) {
	return (
		<div class={cn('mb-4 relative flex items-center justify-between', className)}>
			{typeof header !== 'function' ? (
				<h1 class={cn(`mr-4 text-base font-bold`, titleClassName)} onClick={onHeaderClick}>
					<span>{header}</span>
				</h1>
			) : (
				header(titleClassName, onHeaderClick)
			)}
			<button
				onClick={onClose}
				className={cn(
					'flex-shrink-0 cursor-pointer right-0 top-0 text-dark-blue-50 focus:text-dark-blue hover:text-dark-blue',
					closeButtonClassName,
				)}
				title={closeButtonTitle}
			>
				<Icon type="close" size={24} />
			</button>
		</div>
	);
}
